import { InputHasErrorProp } from './Input'
import { getBaseInputStyles } from './helpers/get-base-input-styles'
import { cn } from '@lib/cn'
import { ChangeEvent, FC, TextareaHTMLAttributes, useRef, useState } from 'react'

export type TextareaProps = InputHasErrorProp &
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    autosize?: boolean
    minRows?: number
    maxRows?: number
    className?: string
  }

export const Textarea: FC<TextareaProps> = ({
  autosize,
  minRows,
  maxRows,
  onChange,
  hasError,
  className,
  ...rest
}) => {
  const lineHeight = 23
  const baseInputStyle = getBaseInputStyles(hasError)
  const ref = useRef<HTMLTextAreaElement | null>(null)
  const [rows, setRows] = useState(minRows || 5)

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (autosize && e.target) {
      const newRows = Math.round(e.target.scrollHeight / lineHeight)
      if (newRows > e.target.rows) {
        if (maxRows) {
          if (newRows < maxRows) {
            setRows(newRows)
          }
        } else {
          setRows(newRows)
        }
      }
    }

    onChange && onChange(e)
  }
  return (
    <textarea
      rows={autosize ? rows : minRows ? minRows : undefined}
      onChange={handleChange}
      ref={ref}
      className={cn(
        baseInputStyle,
        'h-24 min-h-[200px] resize-none border-2 border-solid border-transparent p-6',
        'focus:border-2 focus:border-solid focus:border-rolexPrimary',
        className,
      )}
      {...rest}
    />
  )
}
